<template>
  <span :class="{'active':isActive}"  @click="clickItem(item)" >{{name}}</span>
</template>

<script>
export default {
  name: 'filtersItem',
  props: {
    item:[Object , String],
    name:String,
    // isActive:Boolean
  },
  data(){
    return{
      isActive:false
    }
  },
  methods: {
    clickItem(item){
      this.isActive = !this.isActive;
      this.$emit("clickItem",item)
    }
  },
}
</script>
<style scoped >


</style>